import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import palette from '../theme/palette';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'proposal_id', label: 'Project', alignRight: false },
  { id: 'company', label: 'Bid Amount', alignRight: false },
  { id: 'role', label: 'Attachment', alignRight: false },
  { id: 'isVerified', label: 'Due Date', alignRight: false },
  { id: 'status', label: 'Created At', alignRight: false },
  { id: 'Action', label: "Action", alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function User() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [loading, setLoading] = useState("View Project");

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [user, setUser] = useState(
    {
      "status": true,
      "message": "Login successful!",
      "data": {
          "rating": "0",
          "availability": "offline",
          "status": true,
          "role": "artisan",
          "_id": "6303b359ae52850016ba2d95",
          "phone": "9135403118",
          "country_code": "234",
          "id": "6303b359ae52850016ba2d95",
          "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
          "createdAt": "2022-08-22T16:48:25.655Z",
          "updatedAt": "2022-09-01T23:51:54.155Z",
          "__v": 0,
          "address_str": "10 Juliest ultimate Drive",
          "avatar": "avatar",
          "email": "omonicksonowoeye@gmail.com",
          "first_name": "Omoniyi",
          "last_name": "Omoniyi",
          "location": {
              "type": "Point",
              "coordinates": [
                  7.471104,
                  9.0570752
              ],
              "_id": "6311442da0ebe3001607e006"
          },
          "password": "bml5aW5peWk=",
          "username": "worldest",
          "video": "avatar"
      }
    }
  );

  const [proposals, setProposals] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  useEffect(() => {
    const user_ = localStorage.getItem("user");
    setUser(user_)
    fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/proposals/protisan/${user.data.id}`, {
      method: "GET"
    })
    .then(resposne => resposne.json())
    .then(data => {
      console.log(data);
      localStorage.setItem("proposals", JSON.stringify(data.data));
      setProposals(data.data)
    })
  }, [])
  


  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Proposals">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            My Proposals
          </Typography>
          <Button variant="contained" component={RouterLink} to="../projects" startIcon={<Iconify icon="eva:plus-fill" />}>
            Apply For Projects
          </Button>
        </Stack>

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {proposals.map((row, index) => {
                    // const { id, name, role, status, company, avatarUrl, isVerified } = row;
                    // const isItemSelected = selected.indexOf(name) !== -1;
                    
                    return (
                      <TableRow
                        hover
                        key={index}
                        tabIndex={-1}
                        role="checkbox"
                        selected={false}
                        aria-checked={false}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={false} onChange={(event) => handleClick(event, row.id)} />
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          
                          <a style={{backgroundColor: palette.primary.dark, textDecoration: "none", color: "#fff", marginTop: 30, padding: 15, fontWeight: "900", fontSize: 10, borderRadius: 10}} href="#project-details" onClick={() => {
                            setLoading("Please Wait...");
                            fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/projects/${row.project_id}`, {
                              method: "GET"
                            })
                            .then(resposne => resposne.json())
                            .then(data => {
                              console.log(data);
                              // return false;
                              setLoading("View Project");
                              localStorage.setItem("project_id", data.data.id);
                              localStorage.setItem("project_json", JSON.stringify(data.data));
                              window.location.href = "./project-details"
                            })
                          }}>
                            {loading}
                          </a>
                        </TableCell>
                        <TableCell align="left">{row.bid_amount}</TableCell>
                        <TableCell align="left">
                          <a style={{backgroundColor: palette.primary.dark, textDecoration: "none", color: "#fff", marginTop: 30, padding: 15, fontWeight: "900", fontSize: 10, borderRadius: 10}} rel="noreferrer" target="_blank" href={row.attachment_url}>
                            View
                          </a>
                        </TableCell>
                        <TableCell align="left">{row.due_date}</TableCell>
                        <TableCell align="left">
                          {/* <Label variant="ghost" color={(row.status === 'banned' && 'error') || 'success'}>
                            {sentenceCase(row.status)}
                          </Label> */}
                          {row.createdAt}
                        </TableCell>

                        <TableCell align="right">
                          <UserMoreMenu />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={proposals.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
